var _defs, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVisa = function SvgVisa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1434cb;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path3789",
    className: "cls-1",
    d: "m13.03,6.76c-1.42,0-2.69.74-2.69,2.1,0,1.56,2.25,1.67,2.25,2.45,0,.33-.38.63-1.02.63-.92,0-1.6-.41-1.6-.41l-.29,1.37s.79.35,1.84.35c1.55,0,2.77-.77,2.77-2.16,0-1.65-2.26-1.75-2.26-2.48,0-.26.31-.54.95-.54.73,0,1.32.3,1.32.3l.29-1.33s-.64-.28-1.55-.28h0ZM.03,6.86l-.03.2s.6.11,1.14.33c.69.25.74.4.86.85l1.27,4.9h1.7l2.63-6.28h-1.7l-1.69,4.27-.69-3.62c-.06-.41-.38-.65-.77-.65C2.75,6.86.03,6.86.03,6.86Zm8.25,0l-1.33,6.28h1.62l1.33-6.28h-1.62Zm9.04,0c-.39,0-.6.21-.75.58l-2.38,5.7h1.7l.33-.95h2.07l.2.95h1.5l-1.31-6.28h-1.37Zm.22,1.7l.5,2.36h-1.35l.85-2.36h0Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visa.ca511bc0.svg";
export { ForwardRef as ReactComponent };